import template from './languageSwitcher.html';
import controller from './languageSwitcher.controller';

export const languageSwitcherComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm',
};
